import { dateDeDE, dateEnUS, deDE, enUS } from 'naive-ui'
import type { NDateLocale, NLocale } from 'naive-ui'
import type { KoraWebLocale } from '@/i18n'

/** ADR-010 D7: derived from the effective locale, never stored. */
export const NAIVE_LOCALES: Record<KoraWebLocale, { locale: NLocale; dateLocale: NDateLocale }> = {
  en: { locale: enUS, dateLocale: dateEnUS },
  de: { locale: deDE, dateLocale: dateDeDE }
}
